import { BoxProps, Button, ButtonProps, LinkProps } from '@chakra-ui/react';
import MobileAppButtons from '@core/components/Button/MobileApp/MobileAppButtons';
import { CMS } from '@waitroom/models';
import { isRelativeUrl } from '@waitroom/utils';
import * as React from 'react';
import { Link } from 'react-router-dom';
import HostButton from '../../../auth/components/Button/Host/HostButton';
import { secondaryTextColor } from '../../utils/base';

export type CmsButtonProps = ButtonProps & {
  data: CMS.Link;
  isButton?: boolean;
  layoutBg?: BoxProps['bgColor'];
};

const buttonTypes: Partial<Record<Exclude<CMS.Link['type'], undefined>, React.ComponentType>> = {
  host: HostButton,
};

const styleProps = (isButton: boolean, bgColor: CmsButtonProps['layoutBg']) =>
  isButton
    ? {
        variant: 'solid',
        colorScheme: bgColor === 'red.800' ? 'white' : 'red',
      }
    : {
        variant: 'simple',
        textDecoration: 'underline',
        px: '0 !important',
        color: secondaryTextColor(bgColor),
        colorScheme: 'gray.700',
      };

type CustomLinkProps = ButtonProps & LinkProps & { to?: string };
const linkProps = ({ url, blank }: CmsButtonProps['data']): CustomLinkProps => {
  const isAppUrl = !isRelativeUrl(url);
  const props: CustomLinkProps = {};
  props.as = isAppUrl ? Link : 'a';
  if (blank) {
    props.target = '_blank';
    props.rel = 'noopener noreferrer';
  }
  if (isAppUrl) props.to = url;
  else props.href = url;
  return props;
};

const CmsButton = ({
  data,
  isButton,
  layoutBg,
  ...rest
}: CmsButtonProps): React.ReactElement | null => {
  const { type, linkId } = data;
  if (type === 'mobileApp') {
    return <MobileAppButtons h={rest.h || rest.height} id={linkId} />;
  }
  return (
    <Button
      textAlign="center"
      whiteSpace="normal"
      id={linkId}
      data-id={linkId}
      {...(type && type !== 'default'
        ? {
            as: buttonTypes[type],
          }
        : linkProps(data))}
      {...styleProps(!!isButton, layoutBg)}
      {...rest}
    />
  );
};
export default CmsButton;
